import { Truck, Package, CheckCircle, Clock, AlertCircle } from 'lucide-react';

const Dashboard = () => {
  const stats = [
    { label: 'Trucks Arrived Today', value: '24', icon: Truck, color: 'bg-blue-500' },
    { label: 'Pending QC', value: '8', icon: Clock, color: 'bg-yellow-500' },
    { label: 'Completed GRN', value: '18', icon: CheckCircle, color: 'bg-green-500' },
    { label: 'Issues', value: '2', icon: AlertCircle, color: 'bg-red-500' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-600 mt-2">Welcome to NexGenSIS Supply Chain Management</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => (
          <div key={stat.label} className="card">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">{stat.label}</p>
                <p className="text-3xl font-bold mt-2">{stat.value}</p>
              </div>
              <div className={`${stat.color} p-3 rounded-lg`}>
                <stat.icon className="w-6 h-6 text-white" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card">
          <h2 className="text-xl font-semibold mb-4">Recent Truck Arrivals</h2>
          <div className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium">MH12AB{1234 + i}</p>
                  <p className="text-sm text-gray-600">ABC Supplier</p>
                </div>
                <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
                  In Progress
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <h2 className="text-xl font-semibold mb-4">Dock Status</h2>
          <div className="grid grid-cols-4 gap-2">
            {Array.from({ length: 20 }, (_, i) => (
              <div
                key={i}
                className={`p-3 rounded-lg text-center ${
                  i < 12 ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'
                }`}
              >
                <p className="text-xs font-medium">D{String(i + 1).padStart(2, '0')}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
